import { faLanguage } from "@fortawesome/free-solid-svg-icons";
import { PageConfigs } from "configs/globalInterfaces";

const name = "languages";

export const CONFIGS: PageConfigs = {
  title: name,
  path: `/${name}`,
  icon: faLanguage,
  apiName: `${name}`,
  routeName: name,
  apiAddress: `${name}`,
  componentNames: [name, `${name}s`],
  permissions: [`read:${name}`, `maintain:${name}`],

  // subRoutes: [
  //   { title: "first", path: "/user/first" },
  //   { title: "second", path: "/user/second" },
  // ],
  routes: {
    all: `/${name}/*`,
    base: `/${name}`,
    list: "/list",
    add: `/add`,
    edit: `/edit/:id`,
  },
};
